export default __webpack_public_path__ + "static/evolved_office-4f9baec41b1806a9759ba46c34e2da0b.jpg";